var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.47 135.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.457,
    cy: 70.031,
    r: 37.886,
    fill: "none",
    stroke: "#5a5a5a",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 3.1751
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5a5a5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.72 78.138 5.6086-29.251h1.1217l4.9356 29.474-0.67304 0.66986-8.3008 0.44658z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.751 77.914 0.22435-35.503 1.1217-0.44658 17.499-0.44657 1.1217 1.1164-0.22435 25.678-1.3461 1.1164-7.6278 4.2425-6.506 3.126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.961 67.866-0.22434-14.29 1.1217-1.3397 14.358-3.7959 0.67304 1.563v7.5918l7.8521 3.5726 2.2435-0.89315 1.3461 8.2616-0.4487 8.9315-2.6921 7.8151-4.2626 6.6986-5.1599 5.5822-7.4034 5.5822-7.8521 3.5726 0.44869-36.619 1.7948-0.66986v26.348l1.1217 2.0096 6.7304-5.1356 4.9356-6.9219 2.6922-8.0384 0.22434-8.2616-1.5704-3.5726-3.8139-0.44658-7.1791 1.1164z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.854 103.82 1.3461-1.7863-0.44869-24.115 2.2435 2.4562v20.096l1.1217 1.3397 6.506 0.89315 5.6086-1.1164 2.2435-1.7863 0.67304-5.3589-0.22435-21.436 1.5704-1.1164 0.44869 31.26 1.1217 1.3397 0.44869 2.2329-5.833 1.1164-6.2817 0.22329-6.0573-1.1164-4.0382-1.7863z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.598 94.214-0.22434-8.0384 1.1217-4.4658 1.3461 0.22329-0.67304 6.6986 2.4678 3.7959 5.16 5.3589 2.6922 1.1164 0.67304-2.0096v-10.718l-0.89738-4.0192 1.1217-0.89315 1.5704 4.4658-0.67304 14.737 1.5704 3.3493 0.44869 1.3397-4.4869-1.7863-6.7304-4.689z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.639 73.408 6.2817 4.2425-2.0191 2.4562h-3.8139l-1.3461-3.5726-0.67304-3.5726z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement);
export default __webpack_public_path__ + "static/media/element.f7d87e93581a8a468b8029fce30be3e7.svg";
export { ForwardRef as ReactComponent };